import React from "react";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    useTheme,
} from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { tokens } from "../theme";

const FamilyMemberSelector = ({
    members,
    selectedMemberId,
    onChange,
    label = "Family Member",
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    if (!Array.isArray(members) || members.length <= 1) {
        return null;
    }

    return (
        <Box
            mb={3}
            sx={{
                display: "grid",
                gap: 1.25,
                maxWidth: 420,
            }}
        >
            <Typography
                variant="overline"
                sx={{
                    fontSize: "0.72rem",
                    letterSpacing: "0.18em",
                    color: colors.grey[300],
                    fontWeight: 700,
                }}
            >
                Select which family member to view.
            </Typography>
            <FormControl
                fullWidth
                size="small"
                sx={{
                    "& .MuiOutlinedInput-root": {
                        minHeight: 56,
                        borderRadius: "16px",
                        backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.04)" : "#ffffff",
                        transition: "all 0.2s ease",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.16)" : colors.grey[700],
                        borderWidth: 1,
                    },
                    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: colors.greenAccent[400],
                    },
                    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: colors.blueAccent[400],
                        borderWidth: 2,
                    },
                    "& .MuiInputLabel-root": {
                        fontWeight: 600,
                        letterSpacing: "0.02em",
                    },
                    "& .MuiSelect-select": {
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.98rem",
                        fontWeight: 600,
                    },
                }}
            >
                <InputLabel id="family-member-selector-label">{label}</InputLabel>
                <Select
                    labelId="family-member-selector-label"
                    value={selectedMemberId ? String(selectedMemberId) : ""}
                    label={label}
                    onChange={(event) => onChange(event.target.value)}
                    IconComponent={KeyboardArrowDownRoundedIcon}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                mt: 1,
                                borderRadius: "16px",
                                boxShadow: "0 18px 40px rgba(0, 0, 0, 0.18)",
                            },
                        },
                    }}
                >
                    {members.map((member) => (
                        <MenuItem
                            key={member.member_id}
                            value={String(member.member_id)}
                            sx={{
                                minHeight: 52,
                                display: "flex",
                                alignItems: "center",
                                fontSize: "0.96rem",
                            }}
                        >
                            <Box sx={{ display: "grid", lineHeight: 1.2 }}>
                                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                    {member.first_name} {member.last_name}
                                </Typography>
                                <Typography variant="caption" sx={{ color: colors.grey[300] }}>
                                    Membership ID: {member.membership_id}
                                </Typography>
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default FamilyMemberSelector;